/**
 * Document archive path/status helpers (API lifecycle: archive/{path}).
 */

const APP_DOCS_PREFIX = 'flownotes-app-docs/'

/** True when file_path is under the top-level API archive root (not a nested dated archive/). */
export function isTopLevelArchiveFilePath(filePath: string | null | undefined): boolean {
  if (!filePath) return false
  const p = filePath.replace(/^\/+/, '')
  return p.startsWith('archive/') || p.startsWith(`${APP_DOCS_PREFIX}archive/`)
}

export function isArchivedDocument(opts: {
  status?: string | null
  frontmatter?: Record<string, unknown> | null
  filePath?: string | null
}): boolean {
  if (opts.status === 'archived') return true
  const fmStatus = opts.frontmatter?.status
  if (typeof fmStatus === 'string' && fmStatus === 'archived') return true
  return isTopLevelArchiveFilePath(opts.filePath)
}

/** Strip archive/{...} or flownotes-app-docs/archive/{...} prefix to recover original path. */
export function stripTopLevelArchivePrefix(filePath: string): string {
  const p = filePath.replace(/^\/+/, '')
  if (p.startsWith(`${APP_DOCS_PREFIX}archive/`)) {
    return `${APP_DOCS_PREFIX}${p.slice(`${APP_DOCS_PREFIX}archive/`.length)}`
  }
  if (p.startsWith('archive/')) {
    return p.slice('archive/'.length)
  }
  return p
}

/** Prefer API original_path; else derive from archive file_path. */
export function resolveOriginalPathBeforeArchive(opts: {
  originalPath?: string | null
  filePath?: string | null
}): string | null {
  const fromApi = typeof opts.originalPath === 'string' ? opts.originalPath.trim() : ''
  if (fromApi) return fromApi
  if (opts.filePath && isTopLevelArchiveFilePath(opts.filePath)) {
    return stripTopLevelArchivePrefix(opts.filePath)
  }
  return null
}

/** Parent folder of a content-relative file path (null at root). */
export function parentFolderFromContentPath(filePath: string | null | undefined): string | null {
  if (!filePath || !filePath.includes('/')) return null
  const i = filePath.lastIndexOf('/')
  return i > 0 ? filePath.slice(0, i) : null
}
